import { render } from "./NavCard.vue?vue&type=template&id=be7a63c0&scoped=true"
import script from "./NavCard.vue?vue&type=script&lang=js"
export * from "./NavCard.vue?vue&type=script&lang=js"

import "./NavCard.vue?vue&type=style&index=0&id=be7a63c0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be7a63c0"]])

export default __exports__